module.exports = __webpack_public_path__ + "static/media/recepisse.7155ae2d.pdf";